import { render, staticRenderFns } from "./vue-perfect-scrollbar.vue?vue&type=template&id=4417cff3"
import script from "./vue-perfect-scrollbar.vue?vue&type=script&lang=js"
export * from "./vue-perfect-scrollbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports